
import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage'; 

const Layout = () => import('DD/views/Layout.vue');
const Login = () => import('DD/views/Login/Login.vue');
const ChatAnonymity = () => import('DD/views/ChatAnonymity/ChatAnonymity.vue');
const Home = () => import('DD/views/Home/Home.vue');
const DownLoadCenterAndAFK = () => import('DD/views/DownloadCenter/DownLoadCenterAndAFK.vue');
const Timeout = () => import('DD/views/ErrorHandle/Timeout.vue');
const Offline = () => import('DD/views/ErrorHandle/Offline.vue');
const ErrorMsg = () => import('DD/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('DD/views/ErrorHandle/IPRestricted.vue');
const Register = () => import('DD/views/Register/Register.vue');   
const Bet = () => import('DD/views/Bet/Bet.vue');
const ComboBet = () => import('DD/views/ComboBet/ComboBet.vue');
const Predict = () => import('DD/views/Predict/Predict.vue');
const DrawHistory = () => import('DD/views/DrawHistory/DrawHistory.vue');
const AccountInfo = () => import('DD/views/AccountCenter/AccountInfo.vue');
const Player = () => import('DD/views/Player/Player.vue');
const TradeAgreement = () => import('DD/views/TradeAgreement/TradeAgreement.vue');
const TradeAgreementCurrency = () => import('DD/views/TradeAgreement/TradeAgreement.Currency.vue');
const ExternalGameTrans = () => import('DD/views/ExternalGameTrans/ExternalGameTrans.vue');
const ExternalGameCardSubItem = () => import('DD/views/ExternalGame/ExternalGameCardSubItem.vue');
const ExternalGameFishSubItem = () => import('DD/views/ExternalGame/ExternalGameFishSubItem.vue');
const ExternalGameVideoLobby = () => import('DD/views/ExternalGame/ExternalGameVideoLobby.vue');
const ExternalGameSlotSubItem = () => import('DD/views/ExternalGame/ExternalGameSlotSubItem.vue');
const ExternalGameSportLobby = () => import('DD/views/ExternalGame/ExternalGameSportLobby.vue');
const ExternalGameFishLobby = () => import('DD/views/ExternalGame/ExternalGameFishLobby.vue');
const ExternalGameBlockchain = () => import('DD/views/ExternalGame/ExternalGameBlockchain.vue');
const WithdrawRequest = () => import('DD/views/WithdrawRequest/WithdrawRequest.vue');
const WithdrawRecord = () => import('DD/views/WithdrawRecord/WithdrawRecord.vue');
const ExternalGameTransRecord = () => import('DD/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const BetRecord = () => import('DD/views/BetRecord/BetRecord.vue');
const ScheduleRecord = () => import('DD/views/ScheduleRecord/ScheduleRecord.vue');
const CashFlowRecord = () => import('DD/views/CashFlowRecord/CashFlowRecord.vue');
const AccountSecurity = () => import('DD/views/AccountCenter/AccountSecurity.vue');
const AccountPassword = () => import('DD/views/AccountCenter/AccountPassword.vue');
const DrawLobby = () => import('DD/views/DrawLobby/DrawLobby.vue');
const ProfitReport = () => import('DD/views/ProfitReport/ProfitReport.Main.vue');
const Deposit = () => import('DD/views/Deposit/Deposit.vue');
const DepositQrcode = () => import('DD/views/Deposit/DepositQrcode.vue');
const DepositRecord = () => import('DD/views/DepositRecord/DepositRecord.vue');
const AwardDetail = () => import('DD/views/AwardDetail/AwardDetail.vue');
const Activity = () => import('DD/views/Activity/Activity.vue');
const OneDollarActivity = () => import('DD/views/Activity/OneDollarActivity.vue');
const DailyInterestActivity = () => import('DD/views/Activity/DailyInterest.vue');
const Coupon = () => import('DD/views/Coupon/Coupon.vue');
const FirstDepositByCategoryActivity = () => import('DD/views/Activity/FirstDepositByCategoryActivity.vue');
const DepositConsumeKENO2Activity = () => import('DD/views/Activity/DepositConsumeKENO2Activity.vue');
const DailySigninRedPackActivity = () => import('DD/views/Activity/DailySigninRedPackActivity.vue');
const IFrame = () => import('DD/views/IFrame.vue');
const RecommendFriendRebate = () => import('DD/views/Activity/RecommendFriendRebate.vue' );

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: Login, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/Register', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory, meta: { ignoreAuth: true } },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode},
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        //以下是登入後須套用header、footer、chat的頁面
        {
            path: '/', component: Layout,
            children: [
                { path: '/', name: 'Home', component: Home },
                { path: '/Bet/:id', name: 'Bet', component: Bet },
                { path: '/ComboBet', name: 'ComboBet', component: ComboBet },                
                { path: '/Predict/:id', name: 'Predict', component: Predict },
                { path: '/DownLoadCenterAndAFK', name: 'DownLoadCenterAndAFK', component: DownLoadCenterAndAFK },
                { path: '/AccountInfo', name: 'AccountInfo', component: AccountInfo },
                { path: '/Player', component: Player, meta: { isAgentAllow: true } },
                { path: '/AwardDetail', name: 'AwardDetail', component: AwardDetail },
                { path: '/TradeAgreement', component: TradeAgreement },
                { path: '/TradeAgreementCurrency', component: TradeAgreementCurrency },
                { path: '/ExternalGameTrans', name: 'ExternalGameTrans', component: ExternalGameTrans },

                { path: '/ExternalGameCardSubItem/:gameType', name: 'ExternalGameCardSubItem', component: ExternalGameCardSubItem },
                { path: '/ExternalGameFishSubItem/:gameType', name: 'ExternalGameFishSubItem', component: ExternalGameFishSubItem },
                { path: '/ExternalGameVideoLobby/', name: 'ExternalGameVideoLobby', component: ExternalGameVideoLobby },
                { path: '/ExternalGameSlotSubItem/:gameType', name: 'ExternalGameSlotSubItem', component: ExternalGameSlotSubItem },
                { path: '/ExternalGameSportLobby/', name: 'ExternalGameSportLobby', component: ExternalGameSportLobby },
                { path: '/ExternalGameFishLobby/', name: 'ExternalGameFishLobby', component: ExternalGameFishLobby },
                { path: '/ExternalGameBlockchain/', name: 'ExternalGameBlockchain', component: ExternalGameBlockchain },
                { path: '/WithdrawRequest', name: 'WithdrawRequest', component: WithdrawRequest },
                { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord },

                { path: '/AccountSecurity', name: 'AccountSecurity', component: AccountSecurity },
                { path: '/AccountPassword', name: 'AccountPassword', component: AccountPassword },
                { path: '/ExternalGameTransRecord', name: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: '/BetRecord', name: 'BetRecord', component: BetRecord },
                { path: '/ScheduleRecord', name: 'ScheduleRecord', component: ScheduleRecord },
                { path: '/CashFlowRecord', name: 'CashFlowRecord', component: CashFlowRecord },
                { path: '/DrawLobby', name: 'DrawLobby', component: DrawLobby },
                { path: '/ProfitReport', name: 'ProfitReport', component: ProfitReport },
                { path: '/Deposit', name: 'Deposit', component: Deposit },
                { path: '/DepositRecord', name: 'DepositRecord', component: DepositRecord },
                { path: '/Activity', name: 'Activity', component: Activity },
                { path: '/OneDollarActivity', name: 'OneDollarActivity', component: OneDollarActivity },
                { path: '/DailyInterestActivity', name: 'DailyInterestActivity', component: DailyInterestActivity },
                { path: '/Coupon', name: 'Coupon', component: Coupon },
                { path: '/FirstDepositByCategoryActivity', name: 'FirstDepositByCategoryActivity', component: FirstDepositByCategoryActivity },
                { path: '/DepositConsumeKENO2Activity/:id', name: 'DepositConsumeKENO2Activity', component: DepositConsumeKENO2Activity },
                { path: '/DailySigninRedPackActivity', name: 'DailySigninRedPackActivity', component: DailySigninRedPackActivity },
                { path: '/IFrame', name: 'IFrame', component: IFrame },
                { path: '/RecommendFriendRebate', name: 'RecommendFriendRebate', component: RecommendFriendRebate },
            ]
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/Login');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

// 投注一般、旗艦版導向
router.afterEach(to => {
    if (to.meta.betClientTemplate) {
        storage.local.set(storage.keys.BET_CLIENT_TEMPLATE, to.meta.betClientTemplate);
    }
});

export default router;
